import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
const FilterContext = createContext();
export const FilterProvider = ({ children }) => {
    const [filters, setFilters] = useState({
        selectedCategories: [],
        // other filter states as needed
    });
    const updateSelectedCategories = (selectedCategories) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            selectedCategories: selectedCategories, // Update selected categories
        }));
    };
    return (_jsx(FilterContext.Provider, { value: { filters, updateSelectedCategories }, children: children }));
};
export const useFilterContext = () => {
    const context = useContext(FilterContext);
    if (!context) {
        throw new Error('useFilterContext must be used within a FilterProvider');
    }
    return context;
};
